import React, { useEffect, useState } from "react";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CancelIcon from '@mui/icons-material/Cancel';
import { Grid } from "@mui/material";
import ListOfOpenJobs from "../../components/ListOfOpenJobs/ListOfOpenJobs";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import Card from "../../uicomponents/Card";
import API from "../../utils/Axios.utils";
import CustomModel from "../../utils/CustomModel";
import HoldJobsDetails from "./HoldJobDetails";
import FullFilledJobsDetails from "./FullFilledJobsDetails";
import ClosedCancelledJobsDetails from "./ClosedCancelledJobsDetails";
import useAuth from "../../hooks/useAuth";

const AdminDashboard = () => {
  const [openJob, setOpenJob] = useState("");
  const [closeJob, setCloseJob] = useState("");
  const [fullFilledJob, setFullFilledJob] = useState("");
  const [onHoldJob, setOnHoldJob] = useState("");

  const [openHoldJobModal, setOpenHoldJobModal] = useState(false);
  const handleHoldJobOpen = () => setOpenHoldJobModal(true);
  const handleHoldJobClose = () => setOpenHoldJobModal(false);

  const [openFullFilledJobModal, setOpenFullFilledJobModal] = useState(false);
  const handleFullFilledJobOpen = () => setOpenFullFilledJobModal(true);
  const handleFullFilledJobClose = () => setOpenFullFilledJobModal(false);

  const [openClosedCancelledJobModal, setOpenClosedCancelledJobModal] =
    useState(false);

  const handleClosedCancelledJobOpen = () =>
    setOpenClosedCancelledJobModal(true);

  const handleClosedCancelledJobClose = () =>
    setOpenClosedCancelledJobModal(false);
  const { token } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getJobOpen = async () => {
    try {
      const res = await API.get(`/api/dash/openjob`, config);
      setOpenJob(res?.data?.open_job_count);
    } catch (error) {
      console.log(error);
    }
  };

  const getJobFullFilled = async () => {
    try {
      const res = await API.get(`/api/dash/fullFilledJob`, config);
      setFullFilledJob(res?.data?.close_job_count);
    } catch (error) {
      console.log(error);
    }
  };
  const getJobOnClose = async () => {
    try {
      const res = await API.get(`/api/dash/close_cancelled`, config);
      setCloseJob(res?.data?.closed_job_count || 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getJobOnhold = async () => {
    try {
      const res = await API.get(`/api/dash/holdjob`, config);
      setOnHoldJob(res?.data?.hold_job_count);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getJobOpen();
    getJobOnClose();
    getJobOnhold();
    getJobFullFilled();
  }, []);

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          {/* Card 1 */}
          <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
            <Card
              text="Open"
              number={openJob}
              icon={<BusinessCenterIcon sx={{ fontSize: "50px" }} />}
            />
          </Grid>
          {/* Card 2 */}
          <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
            <Card
              text="On-hold"
              number={onHoldJob}
              icon={<PauseCircleIcon sx={{ fontSize: "50px" }} />}
              onClick={handleHoldJobOpen}
            />
          </Grid>
          {/* Card 3 */}
          <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
            <Card
              text="Fulfilled"
              number={fullFilledJob}
              icon={<EmojiEventsIcon sx={{ fontSize: "50px" }} />}
              onClick={handleFullFilledJobOpen}
            />
          </Grid>
          {/* Card 4 */}
          <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
            <Card
              text="Closed"
              number={closeJob}
              icon={<CancelIcon sx={{ fontSize: "50px" }} />}
              onClick={handleClosedCancelledJobOpen}
            />
          </Grid>
        </Grid>
        <div style={{ marginTop: "20px" }}>
          <ListOfOpenJobs />
        </div>
      </div>
      {/* ✅ Hold Jobs Modal */}
      <CustomModel
        open={openHoldJobModal}
        handleDialog={handleHoldJobClose}
        title="On-hold Jobs"
      >
        {/* Pass handleDialog so child can close if needed, same as SupplierDashboard */}
        <HoldJobsDetails handleClose={handleHoldJobClose} />
      </CustomModel>
      {/* ✅ Full-Filled Jobs Modal */}
      <CustomModel
        open={openFullFilledJobModal}
        handleDialog={handleFullFilledJobClose}
        title="Full-Filled Jobs"
      >
        <FullFilledJobsDetails handleDialog={handleFullFilledJobClose} />
      </CustomModel>

      <CustomModel
        open={openClosedCancelledJobModal}
        handleDialog={handleClosedCancelledJobClose}
        title="Closed / Cancelled Jobs"
      >
        <ClosedCancelledJobsDetails
          handleDialog={handleClosedCancelledJobClose}
        />
      </CustomModel>
    </>
  );
};

export default AdminDashboard;
